"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialog = void 0;
var dialog = {
  variant: {
    touch: {
      maxHeight: 'calc(100% - 40px)'
    }
  },
  sizes: {
    xs: {
      w: 320,
      h: 220
    },
    s: {
      w: 480,
      h: 360
    },
    m: {
      w: 600,
      h: 480
    },
    l: {
      w: 720,
      h: 560
    },
    xl: {
      w: 960,
      h: 640
    },
    xxl: {
      w: 1400,
      h: 800
    }
  }
};
exports.dialog = dialog;